const activity = {
  activity: "Aktiviti", // translated 
  activities: "Aktiviti", // translated 
  dates: "tarikh", // translated 
  location: "Lokasi", // translated 
  languages: "Bahasa-bahasa", // translated 
  categories: "Kategori", // translated 
  ticketOption: "Pilihan Tiket", // translated 
  numberOfRatings: "Bilangan penilaian", // translated 
  meetingPointInfo: "Maklumat titik pertemuan", // translated 
  meetingPoint: "Titik pertemuan", // translated 
  meetingPoints: "Titik pertemuan", // translated 
  providedBy: "Disediakan oleh", // translated 
  expirationDate: "Tarikh luput", // translated 
  groupSize: "Saiz kumpulan", // translated 
  features: "Ciri-ciri", // translated 
  basedOn: "Berdasarkan", // translated 
  reviewsFromVerCustomers: "ulasan daripada pelanggan yang disahkan", // translated 
  excellent: "cemerlang", // translated 
  great: "hebat", // translated 
  average: "purata", // translated 
  poor: "miskin", // translated 
  bad: "teruk", // translated 
  onlyBookedCustomersTooltip:
    "Hanya pelanggan yang menempah aktiviti ini sahaja yang boleh meninggalkan ulasan", // translated 
  noReviewsYet: "Buat masa ini, tiada ulasan untuk aktiviti ini.", // translated 
  backToActivitiesList: "Kembali ke senarai aktiviti", // translated 
  getPrices: "dapatkan harga", // translated 
  availabilityAndPrices: "Ketersediaan dan harga", // translated 
  ticketOptions: "Pilihan tiket", // translated 
  ticketInfo: "Maklumat tiket", // translated 
  selectYourTickets: "Pilih tiket anda", // translated 
  product: "Produk", // translated 
  total: "Jumlah", // translated 
  slot: "Slot", // translated 
  language: "Bahasa", // translated 
  tickets: "Tiket", // translated 
  ticketsFor: "Tiket Untuk", // translated 
  previousStep: "Langkah sebelumnya", // translated 
  onlyAvailableInEnglish: "Hanya tersedia dalam bahasa Inggeris", // translated 
  guest: "Tetamu", // translated 
  leadGuest: "Tetamu utama", // translated 
  adult: "Dewasa", // translated 
  child: "Kanak-kanak", // translated 
  pleaseSelectAdult: "Sila pilih sekurang-kurangnya seorang dewasa", // translated 
  notAvailableActivity: "Produk ini tidak tersedia", // translated 
  required: "Diperlukan", // translated 
  pickupPoint: "Tempat Pengambilan", // translated 
  pickupPoints: "Titik Pengambilan", // translated 
  ticketType: "Jenis Tiket", // translated 
  anonymous: "Tanpa Nama", // translated 
  printedVoucher: "Baucar Bercetak Diterima", // translated 
  mobileVoucher: "Baucar Mudah Alih Diterima", // translated 
  mixedVoucher: "Baucar mudah alih atau bercetak Diterima", // translated 
  safetyMeasures: "Langkah-langkah keselamatan dikenakan", // translated 
  doThisBecause: "Lakukan Ini Kerana", // translated 
  safetyInfo: "Maklumat Keselamatan", // translated 
  reviewsHighestFirst: "Bilangan Ulasan (tertinggi dahulu)", // translated 
  bookingFee: "Yuran Tempahan", // translated 
  startDate: "Tarikh Mula", // translated 
  endDate: "Tarikh Tamat", // translated 
  cancellationDeadlineAndFees: "Tarikh Akhir dan Yuran Pembatalan", // translated 
  resetTickets: "Tetapkan Semula Tiket", // translated 
  instantConfirmation: "Pengesahan Segera", // translated 
  clickResetBtn: "Klik butang tetapkan semula untuk memulakan semula pilihan anda", // translated 
  whatToRemember: "Apa yang perlu diingat", // translated 
};






export default activity;
